/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";
import { ButtonWrap } from "~/components/Utils/ButtonWrap";

const StyledButton = styled(ButtonWrap)`
  margin: 0 0 4px;
  color: ${theme.color.interactive.link};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
};

export function ButtonLink({ children, ...props }: Props) {
  return <StyledButton {...props}>{children}</StyledButton>;
}
